<template v-loading="loading">
  <vue-scroll>
    <el-row>
      <el-alert
        title="Reporte que muestra las terminales por clientes"
        type="info"
        show-icon
        effect="dark"
      >
      </el-alert>
    </el-row>
    <el-row :gutter="10" type="flex" justify="space-between">
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Empresas"
          icon="el-icon-user-solid info-text"
          :total="CantRNCs"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Terminales"
          icon="el-icon-mobile-phone primary-text"
          :total="TotalTerminales"
          :percent="PorcentajeTotal"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Transacciones"
          icon="el-icon-date info-text"
          :total="TotalUltimasTransacciones"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Servicios"
          icon="el-icon-mobile info-text"
          :total="TotalServicios"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Monto Servicios"
          icon="el-icon-coin info-text"
          :total="TotalMontoServicios"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Terminales Activas"
          icon="mdi mdi-satellite-uplink success-text"
          :percent="PorcentajeActivo"
          :total="TotalActivas"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Terminales Inactivas"
          icon="mdi mdi-satellite-uplink danger-text"
          :percent="PorcentajeInactivos"
          :total="TotalInactivas"
          :loading.sync="loading"
        />
      </el-col>
    </el-row>

    <el-row :gutter="60" type="flex" class="row-bg rowx" justify="end">
      <el-col :span="7" id="estado">
        <label class="label" for="estado"> Estado de la empresa: </label>
        <el-select
          size="mini"
          v-model="EstadoTerminal"
          align="center"
          @change="handlechage()"
          @clear="RefreshPage()"
          clearable
          placeholder="Estado Empresa"
        >
          <el-option
            v-for="item in optionsEstadoTerminal"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="6">
        <rabbey-toolbox
          class="mt-0 toolbox"
          :filterables="true"
          @filter-search="onFilterSearch"
        >
          <div class="mr-5">
            <el-button
              type="primary"
              icon="el-icon-refresh"
              size="mini"
              :loading.sync="loading"
              @click="RefreshPage"
              >Actualizar</el-button
            >
          </div>
        </rabbey-toolbox>
      </el-col>
    </el-row>

    <rabbey-table-3
      ref="table"
      class="table"
      :show-summary="true"
      sum-text="Totales de Terminales"
      :loading.sync="loading"
      :columns="columnasTerminales"
      :data.sync="ResultadoTerminales"
      :max-height="700"
      :page-sizes="[10, 30, 50, 100, 500, 1000]"
    />

    <ReportTerminalsDetail ref="detail" />
    <ReportServicesDetails ref="details" />
  </vue-scroll>
</template>

<script>
import axios from "axios";
import ReportTerminalsDetail from "@/components/reports/ReportTerminalsDetail";
import ReportTerminalsHyperLink from "@/components/functionals/ReportTermianlsHyperLink.vue";
import CardTotal from "@/components/CardTotalOriginal.vue";
import { formatMoney } from "@/utils.js";
//import ReportTerminalsServicesHyoerLink from "@/components/functionals/ReportTerminalsServicesHyoerLink";
import ReportServicesDetails from "@/components/reports/ReportServicesDetails.vue";
export default {
  name: "ReportTerminals",
  /*
  props: [
    'token'
  ],
  */
  data() {
    return {
      Token: "",
      EstadoTerminal: "All",
      ClientCode: [],
      user: "@marycorp.com.do",
      pass: "@magycorp2018",
      loading: false,
      ResultadoTerminales: [],
      CantRNCs: Number,
      TQuantity: [],
      columnasTerminales: [
        /*
        {
          prop: "index",
          type: "index",
          width: "300",
          sortable: true
        },
        */
        {
          prop: "RNC",
          label: "RNC de la Empresa",
          sortable: true
        },
        {
          prop: "Nombre",
          label: "Nombre de la Empresa",
          sortable: true
        },
        {
          prop: "CantTotalTerminales",
          label: "Total de Terminales",
          sortable: true,
          align: "center",
          cellAtrrs: {
            OpenTerminalsDetail: this.OpenTerminalsDetail
          },
          formatter: ReportTerminalsHyperLink
        },
        {
          prop: "LastDateCount",
          label: "Total Ultimas Transacciones",
          sortable: true,
          width: 240,
          align: "center"
        },
        {
          prop: "CantTotalServiciosEmp",
          label: "Total de Servicios",
          sortable: true,
          width: 170,
          align: "center"
          /*
          cellAtrrs: {
            OpenServiciosDetail: this.OpenServiciosDetail
          },
          formatter: ReportTerminalsServicesHyoerLink
          */
        },
        {
          prop: "TotalAmountServices",
          label: "Monto en Servicios",
          sortable: true,
          width: 170,
          align: "center",
          // cellAtrrs: {
          //   OpenServiciosDetail: this.ServiciosDetail
          // },
          formatter: (cellValue) => formatMoney(cellValue)
        },
        {
          prop: "CantTeminalesActivas",
          label: "Terminales Activas",
          sortable: true,
          width: 170,
          align: "center",
          cellAtrrs: {
            OpenTerminalsDetail: this.OpenTerminalsDetail
          },
          formatter: ReportTerminalsHyperLink
        },
        {
          prop: "CantTeminalesInactivas",
          label: "Terminales Inactivas",
          sortable: true,
          width: 180,
          align: "center",
          cellAtrrs: {
            OpenTerminalsDetail: this.OpenTerminalsDetail
          },
          formatter: ReportTerminalsHyperLink
        }
      ],
      optionsEstadoTerminal: [
        {
          value: "ACT",
          label: "Activos"
        },
        {
          value: "INA",
          label: "Inactivos"
        },
        {
          value: "All",
          label: "Todos"
        }
      ]
    };
  },
  components: {
    ReportTerminalsDetail,
    CardTotal,
    ReportServicesDetails
  },
  created() {
    this.getToken(this.user, this.pass);

    //this.getCustomers();
  },
  computed: {
    TotalTerminales() {
      return this.ResultadoTerminales.map(
        (item) => item.CantTotalTerminales
      ).reduce((a, b) => a + b);
    },
    TotalActivas() {
      return this.ResultadoTerminales.map(
        (item) => item.CantTeminalesActivas
      ).reduce((a, b) => a + b);
    },
    TotalInactivas() {
      return this.ResultadoTerminales.map(
        (item) => item.CantTeminalesInactivas
      ).reduce((a, b) => a + b);
    },
    PorcentajeTotal() {
      return Math.round((this.TotalTerminales / this.TotalTerminales) * 100);
    },
    PorcentajeActivo() {
      return Math.round((this.TotalActivas / this.TotalTerminales) * 100);
    },
    PorcentajeInactivos() {
      return Math.round((this.TotalInactivas / this.TotalTerminales) * 100);
    },
    TotalServicios() {
      return this.ResultadoTerminales.map(
        (item) => item.CantTotalServiciosEmp
      ).reduce((a, b) => a + b);
    },
    TotalMontoServicios() {
      return this.ResultadoTerminales.map(
        (item) => item.TotalAmountServices
      ).reduce((a, b) => a + b);
    },
    TotalUltimasTransacciones() {
      return this.ResultadoTerminales.map((item) => item.LastDateCount).reduce(
        (a, b) => a + b
      );
    }
  },
  methods: {
    getToken(user, pass) {
      const baseApiAuth = "https://apicloud.magycorp.com:48027/api/login/auth";
      /*
      const config = {
          headers: { 'Access-Control-Allow-Origin': 'http://localhost:8080' }
      }
      */
      const params = {
        Email: user,
        Password: pass
      };
      let self = this; // en axios el scope del this es sobreescrito por ello se usa una variable que contenga el scope anterior del this

      axios
        .post(baseApiAuth, params /* , config */)
        .then(function (response) {
          let { data } = response;
          self.Token = data;

          localStorage.setItem("mpagotoken", data);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.getCompanyandTerminals(self.Token);
        });

      //this.token = self.token
    },

    getCompanyandTerminals(token, Estado = "All") {
      this.loading = true;
      var self = this;
      const baseApiUrl = "https://apicloud.magycorp.com:48027/";
      let apiConsult = `api/empresas/GetEmpresaWithTerminales?status=${Estado}`;

      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      //let rncs = [];
      //this.list = true;
      axios
        .get(baseApiUrl + apiConsult, config)
        .then((resp) => {
          let { data } = resp;

          for (let i = 0; i < data.length; i++) {
            data[i].Empresas_Terminales.length = Number(
              data[i].Empresas_Terminales.length
            );
          }
          self.ResultadoTerminales = data;
          //var index = 0;
          let QuantityxStatus = [];
          self.ResultadoTerminales.forEach((value) => {
            let TerminalesTotales = Number(value.Empresas_Terminales.length);
            let TerminalesTot = value.Empresas_Terminales;
            let TerminalesINA = value.Empresas_Terminales.filter(
              (terminales) => terminales.Status === "INA"
            );
            let TerminalesACT = value.Empresas_Terminales.filter(
              (terminales) => terminales.Status === "ACT"
            );

            let dateCount = 0;

            value.Empresas_Terminales.forEach((terminal) => {
              if (terminal.LastDate) {
                dateCount += 1;
              }
            });

            QuantityxStatus.push({
              RNC: value.Empresa.rnc,
              Nombre: value.Empresa.nombre,
              TeminalesInactivas: TerminalesINA,
              CantTeminalesInactivas: TerminalesINA.length,
              TeminalesActivas: TerminalesACT,
              CantTeminalesActivas: TerminalesACT.length,
              TerminalesTotales: TerminalesTot,
              CantTotalTerminales: TerminalesTotales,
              LastDateCount: dateCount,
              ...value
            });
            //index++;
          });
          self.ResultadoTerminales = QuantityxStatus;

          self.CantRNCs = QuantityxStatus.length;
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          //self.RNCs.forEach(rnc => this.getTerminales(rnc));
          //self.pasingData();
          self.loading = false;
        });
    },

    RefreshPage() {
      this.getCompanyandTerminals(this.Token);
    },
    handlechage() {
      this.getCompanyandTerminals(this.Token, this.EstadoTerminal);
    },

    OpenTerminalsDetail(row, type) {
      this.$refs.detail.show(row, type);
    },

    OpenServiciosDetail(row, type) {
      this.$refs.details.show(row, type);
    },

    onFilterSearch(query) {
      this.$refs.table.filterData(query);
      return;
    }
    /*
    ServiciosDetail(row, type) {
    }
    */
    /*
    getTerminales(RNCs) {
      var self = this;
      const BaseApiUrl =
        "http://apicloud.magycorp.com:48027/api/terminales/getTerminales?";
      const config = {
        headers: { Authorization: `Bearer ${self.token}` }
      };
      const params = "rnc" + "=" + RNCs;
      axios.get(BaseApiUrl + params, config).then(function(response) {
        const { data } = response; 
      
        self.TQuantity.push(data.length);
      });
    },
    
    pasingData(){
      let self = this;
      let index = 0;
      let TItems = [];
      
      this.ResultadoT.forEach(item => {
        
        TItems.push({
          TerminalesQuantity: self.TQuantity[index],
          ...item
        });

        index++;
      });
      this.ResultadoT = TItems;
    }
    */
  }
};
</script>

<style scoped>
.toolbox {
  padding-right: 0px;
}
.label {
  margin-right: 7px;
  margin-top: 3px;
}
</style>
